import { createContext, useContext, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { DataSource, EntityKey, ListQuery } from './source';

const Ctx = createContext<DataSource | null>(null);

export function DataProvider({ source, children }: { source: DataSource; children: ReactNode }) {
  return <Ctx.Provider value={source}>{children}</Ctx.Provider>;
}

export function useDataSource(): DataSource {
  const s = useContext(Ctx);
  if (!s) throw new Error('Thiếu <DataProvider> ở gốc app');
  return s;
}

/** Danh sách một thực thể. Trạng thái (loading / error / empty) theo prop `state` của board. */
export function useList<K extends EntityKey>(entity: K, query: ListQuery = {}) {
  const src = useDataSource();
  return useQuery({ queryKey: ['list', entity, query], queryFn: () => src.list(entity, query) });
}

export function useRecord<K extends EntityKey>(entity: K, id: string | undefined) {
  const src = useDataSource();
  return useQuery({ queryKey: ['get', entity, id], queryFn: () => src.get(entity, id as string), enabled: !!id });
}
